import React, {Component} from 'react';
import { Link, browserHistory } from 'react-router'
import { connect } from 'react-redux';
import Helmet from "react-helmet";

import { setSelectedState } from '../../store/actions/SetSelectedState';

 function mapStateToProps(state) {
    console.log('map state to props', state)
     return {
      selectedState: state.states.selectedState,
      allStates: state.states.allStates
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      setSelectedState: (state) => {
        dispatch(setSelectedState(state))
        browserHistory.push('/state/' + state); 
        console.log('dispatching state', state)
      }
    }
  }

class State extends Component {

  componentWillMount() {
    var state = this.props.params.state;
    this.selectState(state);
  }

  selectState(state) {
    console.log('select state', state)
    this.props.setSelectedState(state);
    window.scrollTo(0, 0);
  }

  render() {
    let { allStates, selectedState } = this.props;

    if (!allStates || !selectedState) {
      return null;
    }

    selectedState = selectedState.toString().toLowerCase()

    let state =allStates.filter(function (entry) { 
      return entry.name.toLowerCase() === selectedState; 
    })[0];


    return (
      <div className="State">
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: this.props.route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <div className="State__info">
          <h1>Marijuana Laws in {state.name}</h1>
          <p>The use of recreational marijuana is legal in {state.name}.</p>
          <h2>Possession</h2>
          <p>{state.possession}</p>
          <h2>Retail Stores</h2>
          <p>{state.retail}</p>
          <h2>Home Grow</h2>
          <p>{state.grow}</p>
          <h2>Legalization Timeline</h2>
          <p>Enacted by: {state.timeline.method}</p>
          <p>Date of vote: {state.timeline.vote}</p>
          <p>Date of legalization: {state.timeline.legalization}</p>
          <p>Date retail stores opened: {state.timeline.retail}</p>
        </div>
        <div className="State__links">
          <h2>View marijuana laws in other legal states</h2>
          <Link to="/state/alaska" onClick={this.selectState.bind(this, 'alaska')}>Alaska</Link>
          <Link to="/state/california" onClick={this.selectState.bind(this, 'california')}>California</Link>
          <Link to="/state/colorado" onClick={this.selectState.bind(this, 'colorado')}>Colorado</Link>
          <Link to="/state/maine" onClick={this.selectState.bind(this, 'maine')}>Maine</Link>
          <Link to="/state/massachusetts" onClick={this.selectState.bind(this, 'massachusetts')}>Massachusetts</Link>
          <Link to="/state/nevada" onClick={this.selectState.bind(this, 'nevada')}>Nevada</Link>
          <Link to="/state/oregon" onClick={this.selectState.bind(this, 'oregon')}>Oregon</Link>
          <Link to="/state/washington" onClick={this.selectState.bind(this, 'washington')}>Washington</Link>
        </div>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(State);






// WEBPACK FOOTER //
// ./src/views/State/State.js